import React, { useContext } from 'react';
import { KibLaunchIcon } from '@chewy/kib-icons-react';
import AnalyticsContext from '../../context/AnalyticsContext';

export default function MemorialContentFooter() {
  const helperCopy = "We're here for you with";
  const linkCopy = 'Loss and memorial resources';

  const analytics = useContext(AnalyticsContext);

  const handleClickedResources = () => {
    analytics.trackRainbow({
      name: 'pet profile memorial - clicked',
      category: 'pet-profile-memorial',
      action: 'click',
      label: 'pet_profile_memorial_loss',
    });
  };

  return (
    <div className="memorial-content-footer" data-testid="memorial-content-footer">
      <span className="memorial-content-footer__text">{helperCopy}</span>&nbsp;
      <a
        href="https://be.chewy.com/forever-loved/"
        onClick={handleClickedResources}
        target="_blank"
        rel="noreferrer noopener"
      >
        {linkCopy.toLowerCase()} <KibLaunchIcon className="memorial-content-footer__icon" />
      </a>
    </div>
  );
}
